import {
  SingleSelectData,
  SingleSelectElement,
} from "@redotech/redo-model/content-builder";
import { InspectorConfig } from "@redotech/redo-web/inspector";
import { memo, useContext, useState } from "react";
import { Flex } from "../../flex";
import { RadioGroup } from "../../radio";
import { BrandKitContext } from "../review-form-editor-contexts";

export const ReviewSingleSelect = memo(function ReviewSingleSelect({
  element,
  setData,
  data,
}: {
  element: SingleSelectElement;
  setData?: (data: SingleSelectData) => void;
  data?: SingleSelectData;
}) {
  const brandKit = useContext(BrandKitContext);

  const [value, setValue] = useState<string | undefined>();

  function handleValueChange(value: string | undefined) {
    if (!value) {
      return;
    }
    setValue(value);
    setData?.({ type: element.type, selectedOption: value });
  }

  const realValue = data?.selectedOption || value;

  const fontFamily = brandKit.font.fontFamily;

  return (
    <Flex style={{ fontFamily }}>
      <RadioGroup
        optionLabel={(option) => option}
        options={element.options}
        value={realValue}
        valueChange={(value) => {
          handleValueChange(value);
        }}
      />
    </Flex>
  );
});

export const reviewSingleSelectInspector: InspectorConfig<SingleSelectElement> =
  {
    sections: [
      {
        label: "Single choice",
        fields: [
          {
            widget: "chip",
            path: "options",
          },
          {
            widget: "toggle",
            path: "required",
            label: "Required",
          },
        ],
      },
    ],
  };
